import BaseRequest from './BaseRequest';

const schema = 'order-transaction';

export default class OrderTransactionHistoryRequest extends BaseRequest {
  fetchFilterOrderTransactionHistory(params) {
    const url = `${schema}/all`;
    return this.get(url, params);
  }

  fetchUserOrderTransHistory(params) {
    const url = `${schema}/user-history`;
    return this.get(url, params);
  }

  searchByOrderTrans(params) {
    const url = `${schema}/single`;
    return this.get(url, params);
  }
}
